/* Pet Dash theme script: header, add to cart, reveals, product page controls. */
(function () {
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const routes = (window.PetDash && window.PetDash.routes) || { cart: "/cart", cartAdd: "/cart/add" };

  // Header: search overlay, mobile menu, shadow on scroll
  const box = $("#search-bar-container"), input = $("#search-input");
  const toggleSearch = () => { if (!box) return; box.classList.toggle("active"); if (box.classList.contains("active")) setTimeout(() => input && input.focus(), 100); };
  $("#search-trigger-btn") && $("#search-trigger-btn").addEventListener("click", toggleSearch);
  $("#close-search-btn") && $("#close-search-btn").addEventListener("click", toggleSearch);
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && box && box.classList.contains("active")) toggleSearch(); });
  const menuBtn = $("#menu-btn"), menu = $("#mobile-menu");
  if (menuBtn && menu) menuBtn.addEventListener("click", () => {
    const open = menu.classList.toggle("open");
    menuBtn.setAttribute("aria-expanded", String(open));
    menuBtn.innerHTML = `<iconify-icon icon="lucide:${open ? "x" : "menu"}" width="24" noobserver></iconify-icon>`;
    document.body.style.overflow = open ? "hidden" : "";
  });
  const nav = $("#navbar");
  const calm = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  // Keep icons drawn. By default they erase themselves off-screen and redraw on the way back, which reflows the page while scrolling.
  $$("iconify-icon").forEach((i) => i.setAttribute("noobserver", ""));

  // Smooth scrolling (Lenis). Desktop wheel and trackpad only; phones keep native scrolling.
  let lenis = null;
  if (!calm && window.Lenis) {
    lenis = new window.Lenis({ autoRaf: true, lerp: 0.09, smoothWheel: true, anchors: { offset: -80 } });
    menu && menu.setAttribute("data-lenis-prevent", "");
    if (menuBtn && menu) menuBtn.addEventListener("click", () => (menu.classList.contains("open") ? lenis.stop() : lenis.start()));
  }

  // Header: soft shadow once scrolled, tucks away going down, returns going up.
  // Everything here runs once per frame, so it only does math on cached numbers and
  // touches the DOM when something actually changes (no layout reads while scrolling).
  const parallax = $$("[data-parallax]").map((el) => ({ el, k: parseFloat(el.dataset.parallax) || 0.06, top: 0, h: 0, last: null }));
  let vh = window.innerHeight, maxY = 0;
  function measure() {
    vh = window.innerHeight;
    maxY = Math.max(0, document.documentElement.scrollHeight - vh);
    const y = window.scrollY;
    parallax.forEach((p) => {
      const prev = p.el.style.translate; p.el.style.translate = "";
      const r = p.el.parentElement.getBoundingClientRect();
      p.top = r.top + y; p.h = r.height; p.el.style.translate = prev;
    });
  }
  let lastY = window.scrollY, shadowOn = null, hidden = false, ticking = false;
  function onScroll() {
    ticking = false;
    // Clamp so the iPhone bounce at the top and bottom of the page doesn't count as scrolling back up
    const y = Math.min(Math.max(lenis ? lenis.scroll : window.scrollY, 0), maxY);
    if (nav) {
      const wantShadow = y > 20;
      if (wantShadow !== shadowOn) { shadowOn = wantShadow; nav.classList.toggle("pd-scrolled", wantShadow); }
      const busy = (menu && menu.classList.contains("open")) || (box && box.classList.contains("active"));
      let wantHide = hidden;
      if (!calm && !busy && y > 240 && y > lastY + 6) wantHide = true;
      else if ((y < lastY - 10 && y < maxY - 120) || y <= 240 || busy) wantHide = false;
      if (wantHide !== hidden) { hidden = wantHide; nav.classList.toggle("pd-hide", wantHide); }
    }
    // Parallax: bags drift a little slower than the page
    if (!calm) {
      parallax.forEach((p) => {
        const rel = p.top - y;
        if (rel + p.h < -200 || rel > vh + 200) return;
        const v = ((rel + p.h / 2 - vh / 2) * p.k).toFixed(1);
        if (v !== p.last) { p.last = v; p.el.style.translate = `0 ${v}px`; }
      });
    }
    lastY = y;
  }
  measure();
  if (lenis) lenis.on("scroll", onScroll);
  else window.addEventListener("scroll", () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  let rt; const remeasure = () => { clearTimeout(rt); rt = setTimeout(() => { measure(); onScroll(); }, 150); };
  window.addEventListener("resize", remeasure, { passive: true });
  window.addEventListener("load", remeasure);
  if ("ResizeObserver" in window) new ResizeObserver(remeasure).observe(document.body);
  onScroll();

  // Headlines: wrap each word so it can rise into view
  function splitWords(el) {
    let i = 0;
    const walk = (node) => {
      Array.from(node.childNodes).forEach((child) => {
        if (child.nodeType === 3) {
          const parts = child.textContent.split(/(\s+)/);
          const frag = document.createDocumentFragment();
          parts.forEach((p) => {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(" ")); return; }
            const w = document.createElement("span"); w.className = "pd-w";
            const inner = document.createElement("span"); inner.textContent = p; inner.style.setProperty("--i", i++);
            w.appendChild(inner); frag.appendChild(w);
          });
          child.replaceWith(frag);
        } else if (child.nodeType === 1 && child.tagName !== "BR") walk(child);
      });
    };
    el.setAttribute("aria-label", (el.innerText || el.textContent).replace(/\s+/g, " ").trim());
    walk(el);
    el.querySelectorAll(".pd-w").forEach((w) => w.setAttribute("aria-hidden", "true"));
    el.classList.add("pd-split");
  }
  const headlines = calm ? [] : $$("main h1.font-display, main h2.font-display");
  headlines.forEach((h) => {
    const inHero = h.classList.contains("animate-fade-in-up");
    if (inHero) { h.classList.remove("animate-fade-in-up", "opacity-0", "delay-100"); h.style.setProperty("--d", "120ms"); }
    splitWords(h);
  });

  // Hero bags lift into place one after another
  if (!calm) $$("[data-hero-bags] img").forEach((img, i) => { img.classList.add("pd-rise"); img.style.animationDelay = 450 + i * 140 + "ms"; });

  // The CTA puppy trots in place; cards lift on hover
  const floaters = calm ? [] : $$("main img[src*='pet-dash-mark']").filter((img) => !img.closest(".pd-lockup") && !img.closest("[data-hero-bags]"));
  floaters.forEach((img) => img.classList.add("pd-float"));
  // The puppy only trots while it's on screen, and starts once it has settled into place
  if (floaters.length && "IntersectionObserver" in window) {
    const fo = new IntersectionObserver((entries) => entries.forEach((e) => {
      const img = e.target;
      clearTimeout(img._pdT);
      if (e.isIntersecting) img._pdT = setTimeout(() => img.classList.add("is-on"), 1100);
      else img.classList.remove("is-on");
    }), { threshold: 0 });
    floaters.forEach((img) => fo.observe(img));
  }
  $$("main .reveal.rounded-2xl, main .rounded-xl.border.bg-white").forEach((el) => el.classList.add("pd-lift"));

  // Grids that reveal as one block reveal card by card instead
  $$(".reveal.grid").forEach((grid) => {
    grid.classList.remove("reveal");
    Array.from(grid.children).forEach((c, i) => { c.classList.add("reveal"); c.style.transitionDelay = i * 70 + "ms"; });
  });

  // Scroll reveals (blocks and headlines)
  const show = (el) => {
    el.classList.add(el.classList.contains("pd-split") ? "is-in" : "active");
    if (el.style.transitionDelay) setTimeout(() => (el.style.transitionDelay = ""), 1600); // stagger only on the way in, not on hover
  };
  if ("IntersectionObserver" in window && !calm) {
    const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } }), { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    $$(".reveal").forEach((el) => io.observe(el));
    headlines.forEach((h) => io.observe(h));
  } else { $$(".reveal").forEach((el) => el.classList.add("active")); headlines.forEach((h) => h.classList.add("is-in")); }

  // Toast
  function toast(text) {
    let el = $("#pd-toast");
    if (!el) {
      el = document.createElement("div");
      el.id = "pd-toast"; el.setAttribute("role", "status");
      el.className = "fixed bottom-6 left-1/2 z-[80] flex items-center gap-4 bg-neutral-900 text-white text-sm px-5 py-3.5 rounded-full shadow-2xl opacity-0 pointer-events-none max-w-[calc(100vw-32px)]";
      el.style.transform = "translate(-50%, 12px)";
      document.body.appendChild(el);
    }
    el.innerHTML = `<iconify-icon icon="lucide:check" width="16" class="text-dash-200 shrink-0" noobserver></iconify-icon><span class="truncate"></span><a href="${routes.cart}" class="shrink-0 font-semibold text-dash-200 hover:text-white underline underline-offset-4">View cart</a>`;
    el.querySelector("span").textContent = text;
    el.classList.add("show");
    clearTimeout(el._t); el._t = setTimeout(() => el.classList.remove("show"), 3200);
  }
  function setCount(n) { $$("[data-cart-count]").forEach((el) => { el.textContent = n; el.classList.toggle("hidden", !n); }); }

  async function addToCart(id, qty, name) {
    const res = await fetch(routes.cartAdd + ".js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Math.max(1, Number(qty) || 1) }] })
    });
    const data = await res.json();
    if (!res.ok) { toast(data.description || "Couldn't add that to your cart."); return; }
    const cart = await (await fetch(routes.cart + ".js")).json();
    setCount(cart.item_count);
    toast(`Added ${name || "it"} to your cart`);
  }

  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-add]");
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    addToCart(b.dataset.add, 1, b.dataset.name).finally(() => (b.disabled = false));
  });

  // Product page
  const form = $("[data-product-form]") || $("#product-form");
  if (form) {
    const qty = $("#qty", form);
    $$("[data-qty]", form).forEach((btn) => btn.addEventListener("click", () => {
      if (!qty) return; qty.value = Math.min(20, Math.max(1, (Number(qty.value) || 1) + Number(btn.dataset.qty)));
    }));
    $$('input[type="radio"][name="id"]', form).forEach((r) => r.addEventListener("change", () => {
      const price = $("#price"); if (price) { price.textContent = r.dataset.price; price.classList.toggle("text-neutral-400", r.dataset.price === "Price soon"); }
      const pill = $("#size-pill"); if (pill) pill.textContent = r.dataset.title + " bag";
      const img = $("#main-image"); if (img && r.dataset.image) { img.removeAttribute("srcset"); img.src = r.dataset.image; }
      const u = new URL(location.href); u.searchParams.set("variant", r.value); history.replaceState(null, "", u);
    }));
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const idEl = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
      const btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
      const title = (document.querySelector("h1") || {}).textContent || "";
      addToCart(idEl.value, qty ? qty.value : 1, title.trim()).finally(() => btn && (btn.disabled = false));
    });
  }
  $$("[data-thumb]").forEach((t) => t.addEventListener("click", () => { const img = $("#main-image"); if (img) { img.removeAttribute("srcset"); img.src = t.dataset.thumb; } }));
})();
